import React from 'react';
import { ProgressView, SatCoreRegister, StudentHelperService } from 'sat-core';

import iconCommentActiveYellow from '../img/icon-comment-active-yellow.svg';

// const ProgressViewSummaryLegend = ({ data }) => {
//   return StudentHelperService.getProgressSummaryLegend({ data });
// };

const ProgressViewOverride = (props) => {
  const progressViewOverrideOptions = StudentHelperService.getProgressViewOverrideOptions({
    progressWidget: true,
    summaryWidget: false,
    trophiesWidget: true,
    weeklyPerformanceWidget: false
  });
  return (
    <ProgressView {...props} {...progressViewOverrideOptions}
      // summaryLegend={ProgressViewSummaryLegend}
      feedbackIconActiveImg={iconCommentActiveYellow}
      leftCol={true} />
  );
};

SatCoreRegister('ProgressView', ProgressViewOverride);
